import useSpaceyConfig from './useSpaceyConfig';

/**
 * Resolved Spacey avatar for the active market (CMS URL or bundled SVG).
 */
export const useSpaceyIcon = (countryCodeOverride) => useSpaceyConfig(countryCodeOverride).iconSrc;

export default useSpaceyIcon;
